import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    text: 'Excelente servicio, mi paquete llegó en perfectas condiciones a Barquisimeto. ¡Muy recomendados!',
    initials: 'MG'
  }, {
    name: 'Carlos R.',
    text: 'Siempre atentos y puntuales. La mejor opción para enviar a Venezuela.',
    initials: 'CR'
  }, {
    name: 'Ana P.',
    text: 'Me encanta la atención personalizada. Se siente como enviar con familia.',
    initials: 'AP'
  }];
  return <section className="py-16 md:py-24 bg-[#F8F9FA]" data-id="element-158">
      <div className="container mx-auto px-4 md:px-6" data-id="element-159">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-[#1B2B5E]" data-id="element-160">
          Lo que dicen nuestros clientes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-161">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-shadow relative" data-id="element-162">
              <div className="text-[#F5A623] opacity-20 absolute top-6 right-8 text-6xl font-serif leading-none" data-id="element-163">
                "
              </div>

              <div className="flex gap-1 mb-6" data-id="element-164">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-[#F5A623] text-[#F5A623]" data-id="element-165" />)}
              </div>

              <p className="text-gray-600 mb-8 italic relative z-10" data-id="element-166">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-167">
                <div className="w-12 h-12 rounded-full bg-[#1B2B5E] text-white flex items-center justify-center font-bold text-lg" data-id="element-168">
                  {testimonial.initials}
                </div>
                <div data-id="element-169">
                  <h4 className="font-bold text-[#1B2B5E]" data-id="element-170">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-171">Cliente Verificado</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}